import { Amex, Pay, VPlus } from "@/entities";
import { IPayRepository } from "./pay.types";
import { IOrder, Order } from "@/entities/order/order";
import axios from "axios"
import { API } from "aws-amplify";

export const QR_WALLET_GENERATE_ENDPOINT = "https://qq5zwl3jma.execute-api.ap-southeast-1.amazonaws.com/Dev/public/payment/v1/saletool/qr/pay";
export const QR_WALLET_INQUIRY_ENDPOINT = "https://qq5zwl3jma.execute-api.ap-southeast-1.amazonaws.com/Dev/public/payment/v1/saletool/qr-pay/info";
export const CARD_PAYMENT_ENDPOINT = "https://q0isgggx54.execute-api.ap-southeast-1.amazonaws.com/Prod/public/m-payment/v1/saletool/payment/card";
// export const CARD_PAYMENT_ENDPOINT = "https://qq5zwl3jma.execute-api.ap-southeast-1.amazonaws.com/Dev/public/m-payment/v1/saletool/payment/card";
// export const CARD_PAYMENT_ENDPOINT = "https://shop.villamarket.com/api/kwallet-frontend/public/m-payment/v1/saletool/payment/card";

// export const QR_WALLET_GENERATE_ENDPOINT = "https://shop.villamarket.com/api/kwallet-frontend/customer/payment/v1/ecommerce/qr/pay";
// export const QR_WALLET_INQUIRY_ENDPOINT = "https://shop.villamarket.com/api/kwallet-frontend/customer/payment/v1/ecommerce/qr-pay/info";

export class PayAPIRepository implements IPayRepository {
    async creditcardReq(orderId: string): Promise<Pay | undefined> {
        const body = JSON.stringify({
            orderId: orderId,
        });
        const response = await axios.post('https://k5y2jog2b2.execute-api.ap-southeast-1.amazonaws.com/Prod/creditcard-req', body)
        if (response.status === 200) {
            // console.log("creditcardReq", response.data);
            const data = {
                version: response.data.version,
                merchantId: response.data.merchant_id,
                paymentDescription: response.data.payment_description,
                orderId: response.data.order_id,
                currency: response.data.currency,
                amount: response.data.amount,
                userDefined1: response.data.user_defined_1,
                userDefined2: response.data.user_defined_2,
                enableStoreCard: response.data.enable_store_card,
                request3ds: response.data.request_3ds,
                hashValue: response.data.hash_value,
            }
            return new Pay(data)
        }
        else {
            throw new Error(`Failed to load credit card data`);
        }
    }
    async APMReq(orderId: string): Promise<Pay | undefined> {
        const body = JSON.stringify({
            orderId: orderId,
        });
        const response = await axios.post('https://k5y2jog2b2.execute-api.ap-southeast-1.amazonaws.com/Prod/apm-req', body)
        if (response.status === 200) {
            // console.log("creditcardReq", response.data);
            const data = {
                version: response.data.version,
                merchantId: response.data.merchant_id,
                paymentDescription: response.data.payment_description,
                orderId: response.data.order_id,
                currency: response.data.currency,
                amount: response.data.amount,
                userDefined1: response.data.user_defined_1,
                userDefined2: response.data.user_defined_2,
                enableStoreCard: response.data.enable_store_card,
                request3ds: response.data.request_3ds,
                hashValue: response.data.hash_value,
            }
            return new Pay(data)
        }
        else {
            throw new Error(`Failed to load credit card data`);
        }
    }
    async AMEXReq(orderId: string): Promise<Amex | undefined> {
        const body = JSON.stringify({
            orderId: orderId,
        });
        const response = await axios.post('https://k5y2jog2b2.execute-api.ap-southeast-1.amazonaws.com/Prod/amex-req', body)
        if (response.status === 200) {
            return new Amex(response.data)
        }
        else {
            throw new Error(`Failed to load AMEX data`);
        }
    }

    async AMEXV2Req(orderId: string, amount: number): Promise<Amex | undefined> {
        const body = {
            orderId: orderId,
            amount,
            currency: "THB"
        }
        const response = await axios.post('https://qq5zwl3jma.execute-api.ap-southeast-1.amazonaws.com/Dev/public/m-payment/v1/saletool/card/init', body)
        if (response.status === 200) {
            return new Amex(response.data.data)
        }
        else {
            throw new Error(`Failed to load AMEX data`);
        }
    }

    async WalletReq(orderId: string, mobile: string): Promise<VPlus | undefined> {
        // const body = JSON.stringify({
        //     orderId: orderId,
        //     // memberId: memberId,
        //     // mobile: mobile,
        //     phone_number: mobile,
        // });
        const body = {
            orderId: orderId,
            phone_number: mobile
        }
        console.log(body);
        try {
            const response = await axios.post('https://93p9ky97ak.execute-api.ap-southeast-1.amazonaws.com/Prod/wallet', body)
            if (response.status === 200) {
                // console.log("creditcardReq", response.data);
                return new VPlus({ statusCode: response.data.result_code, message: response.data.result_message, data: response.data })
            }
        } catch (e: any) {
            const { error } = e.response.data;
            return new VPlus({ statusCode: error.result_code, message: error.result_message, data: error.data })
        }
        // else {
        //     throw new Error(`Failed to load VPLus data`);
        // }
    }
    async PayAtStore(orderId: string, payload: any): Promise<any> {
        console.log("PayAtStore API payload:", orderId, payload);

        return API.post("saletoolapi", "/payAtStore", {
            body: payload,
        });
    }
    async CreateKBankQrPayment(orderId: string, type: string, amount: number, token: string): Promise<any> {
        const payload = {
            orderId: orderId,
            method: type,
            amount: amount,
        }

        console.log("CreateKBankQrPayment API payload:", payload);
        const response = await axios.post('https://kibxkqpe7d.execute-api.ap-southeast-1.amazonaws.com/production/api/v1/payment/qr', payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            }
        })

        return response.data.Data
    }
    async GenerateQRWalletPayment(payload: Record<string, string | number>, token: string): Promise<any> {
        try {
            const response = await axios.post(
                QR_WALLET_GENERATE_ENDPOINT,
                {
                    amount: payload.amount,
                    currency: payload.currency || "THB",
                    orderId: payload.orderId,
                    ticket: payload.ticket || payload.orderId,
                    saleId: payload.saleId,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 && response.data.status) {
                return response.data;
            }

            throw new Error(response.data.message || "Failed to generate QR payment");
        } catch (error: any) {
            console.error("QR Wallet Generate Error:", error);
            const msg = error.response?.data?.message ?? "Failed to generate QR payment";
            throw new Error(msg);
        }
    }

    async CardPaymentInit(payload: Record<string, string | number>, token: string): Promise<any> {
        const response = await axios.post(
            `${CARD_PAYMENT_ENDPOINT}/init`,
            {
                orderId: payload.orderId,
                amount: payload.amount,
                currency: payload.currency || "THB",
                redirectResponseUrl: payload.redirectResponseUrl,
                saleId: payload.saleId,
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
        return response.data.data;
    }
    async CardPaymentPay(payload: Record<string, string | number | boolean>, token: string): Promise<any> {
        try {
            const response = await axios.post(
                `${CARD_PAYMENT_ENDPOINT}/pay`,
                payload,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            if (response.data.redirectUrl) {
                return response.data;
            }
            return response.data.data;
        } catch (error: any) {
            // gateway may answer non-2xx but still hand back a redirectUrl (e.g. declined page)
            if (error.response?.data?.redirectUrl) {
                return error.response.data;
            } else if (error.response?.data?.data?.redirectUrl) {
                return error.response.data.data;
            }
            throw error;
        }
    }
    async InquireQRWalletPayment(paymentId: string, token: string): Promise<any> {
        try {
            const response = await axios.get(
                `${QR_WALLET_INQUIRY_ENDPOINT}/${paymentId}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 && response.data.status) {
                return response.data;
            }

            throw new Error(response.data.message || "Failed to inquire payment status");
        } catch (error: any) {
            console.error("QR Wallet Inquiry Error:", error);
            const msg = error.response?.data?.message ?? "Failed to inquire payment status";
            throw new Error(msg);
        }
    }
}